<cdx-button-group [formGroup]="quantityForm">
	<form-input
		#quantityInput
		cdxInput
		cdxNumeric
		[autocomplete]="null"
		class="qty-inTrolleyLabel"
		[ngClass]="{ 'with-label': customLabel }"
		formControlName="quantity"
		[id]="name"
		maxlength="5"
		[inputMode]="inputMode"
		[attr.data-unit]="unit"
		[selectOnClick]="true"
		(blur)="inputHasFocus = false"
		(focus)="inputHasFocus = true"
		(keyup)="inputKeyup($event)"
		attr.data-cy="inputField-{{ name }}"
		[readonly]="disableKeyboardInput"
	>
		<label [ngClass]="{ 'sr-only': !customLabel }" [for]="name" label>
			<ng-container *ngIf="!customLabel" i18n="@@quantityForm-manualEntry">{{ quantityLabel }}</ng-container>
			<ng-container *ngIf="customLabel">{{ customLabel }}</ng-container>
		</label>
	</form-input>
	<ng-container *ngIf="showDoneButton; then doneButton; else incrementDecrementButton"></ng-container>
	<ng-template #doneButton>
		<button
			cdxButton
			class="qty-doneBtn"
			fillStyle="secondary"
			type="button"
			(click)="update()"
			i18n="@@quantity-doneButton"
			aria-label="Add the desired quantity to basket"
			attr.data-cy="add-Button-{{ name }}"
		>
			Add
		</button>
	</ng-template>
	<ng-template #incrementDecrementButton>
		<button
			#decrementButton
			cdxButton
			fillStyle="secondary"
			type="button"
			class="qty-decrement"
			[attr.aria-label]="decrementLabel"
			[disabled]="!canDecrement"
			(click)="decrement()"
			attr.data-cy="decrement-{{ name }}"
		>
			<cdx-svg-icon [size]="buttonIconSize" name="minus"></cdx-svg-icon>
		</button>
		<button
			#incrementButton
			cdxButton
			fillStyle="secondary"
			type="button"
			class="qty-increment"
			[attr.aria-label]="incrementLabel"
			[disabled]="!canIncrement"
			(click)="increment()"
			attr.data-cy="increment-{{ name }}"
		>
			<cdx-svg-icon [size]="buttonIconSize" name="plus"></cdx-svg-icon>
		</button>
	</ng-template>
</cdx-button-group>
